import { render, staticRenderFns } from "./ObjectTemplates.vue?vue&type=template&id=003bc982&"
import script from "./ObjectTemplates.vue?vue&type=script&lang=js&"
export * from "./ObjectTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTemplates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports